module.exports = __webpack_public_path__ + "my.svg?7299f57923a7a0200d2a8aafee760fa2";